import { render } from "./Xcxbanner.vue?vue&type=template&id=13e52ca2&scoped=true"
import script from "./Xcxbanner.vue?vue&type=script&lang=js"
export * from "./Xcxbanner.vue?vue&type=script&lang=js"

import "./Xcxbanner.vue?vue&type=style&index=0&id=13e52ca2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13e52ca2"]])

export default __exports__